
(function () {
  'use strict';

  // Product gallery and quantity buttons
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-shp-thumb]');

    if (thumb) {
      var root = thumb.closest('.shp');
      var main = root && root.querySelector('[data-shp-main]');

      if (main) {
        main.src = thumb.dataset.full;

        root.querySelectorAll('[data-shp-thumb]').forEach(function (item) {
          item.classList.remove('is-active');
        });

        thumb.classList.add('is-active');
      }
    }

    var button = e.target.closest('[data-shp-qty]');

    if (button) {
      var input = button.closest('.shp__qty').querySelector('input[name="quantity"]');

      if (!input) return;

      var min = Math.max(1, parseInt(input.min, 10) || 1);
      var step = Math.max(1, parseInt(input.step, 10) || 1);
      var current = parseInt(input.value, 10) || min;
      var change = parseInt(button.dataset.shpQty, 10) || 0;

      input.value = Math.max(min, Math.ceil((current + change * step) / step) * step);

      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // Product variant selection
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-shp-option]')) return;

    var root = e.target.closest('.shp');
    if (!root) return;

    var selects = Array.from(root.querySelectorAll('[data-shp-option]'));
    var data = root.querySelector('[data-shp-variants]');
    if (!data) return;

    var variants;

    try {
      variants = JSON.parse(data.textContent);
    } catch (error) {
      return;
    }

    var variant = variants.find(function (item) {
      return selects.every(function (select, index) {
        return item.options[index] === select.value;
      });
    });

    if (!variant) return;

    var id = root.querySelector('[data-shp-id]');
    if (id) id.value = variant.id;

    var qty = root.querySelector('.shp__qty input[name="quantity"]');
    var rulesEl = root.querySelector('[data-shp-variant-rules]');
    if (qty && rulesEl) {
      try {
        var rules = JSON.parse(rulesEl.textContent || '{}');
        var rule = rules[String(variant.id)] || {};
        var min = Math.max(1, parseInt(rule.minimum, 10) || 1);
        var step = Math.max(1, parseInt(rule.increment, 10) || 1);
        qty.min = String(min);
        qty.step = String(step);
        qty.value = String(min);
      } catch (error) { console.warn('Quantity rule could not be loaded', error); }
    }

    var price = root.querySelector('[data-shp-price]');

    if (price) {
      price.textContent = (variant.price / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      });
    }

    var addButton = root.querySelector('.shp__atc');

    if (addButton) {
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
  });

  // Normalize typed quantities to Shopify's B2B minimum and increment.
  document.addEventListener('change', function (e) {
    if (!e.target.matches('.shp__qty input[name="quantity"]')) return;
    var input = e.target;
    var min = Math.max(1, parseInt(input.min, 10) || 1);
    var step = Math.max(1, parseInt(input.step, 10) || 1);
    var value = parseInt(input.value, 10) || min;
    input.value = String(Math.max(min, Math.ceil(value / step) * step));
  });

  // Submit the selected variant and the actual product-page quantity.
  document.addEventListener('submit', async function (e) {
    var form = e.target;

    if (!form.matches('.shp form[action*="/cart/add"]')) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var root = form.closest('.shp');
    var quantityInput = form.querySelector('input[name="quantity"]');
    var variantInput = form.querySelector('input[name="id"]');
    var addButton = form.querySelector('[type="submit"]');

    if (!root || !variantInput || !variantInput.value) return;

    var min = Math.max(1, parseInt(quantityInput && quantityInput.min, 10) || 1);
    var step = Math.max(1, parseInt(quantityInput && quantityInput.step, 10) || 1);
    var quantity = Math.max(min, Math.ceil((parseInt(quantityInput && quantityInput.value, 10) || min) / step) * step);

    if (quantityInput) quantityInput.value = quantity;

    var data = new FormData(form);
    data.set('id', variantInput.value);
    data.set('quantity', String(quantity));

    if (addButton) {
      addButton.disabled = true;
      addButton.textContent = 'Adding...';
    }

    try {
      var response = await fetch(
        (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js',
        {
          method: 'POST',
          body: data,
          headers: {
            'Accept': 'application/json'
          }
        }
      );

      if (!response.ok) {
        var error = await response.json().catch(function () { return {}; });
        throw new Error(error.description || error.message || 'Unable to add to cart');
      }

      // Notify theme components that the cart contents changed.
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

      // Refresh the page to display the updated cart reliably.
      window.location.reload();

    } catch (error) {
      alert(error.message || 'Could not add this product to your cart.');

      if (addButton) {
        addButton.disabled = false;
        addButton.textContent = 'Add to Cart';
      }
    }
  }, true);
})();
